export default __webpack_public_path__ + "023a35a54a88f336ceb880cc0b14f65f.png";